import type { PdfComponentSpacerI } from '../typed';

const TermsAndConditionsRenderSpacer: React.FunctionComponent<PdfComponentSpacerI> =
  function ({ margin }) {
    return (
      <div className="flex flex-col w-full">
        <div
          style={{
            height: `${margin}px`,
            minHeight: `${margin}px`,
            maxHeight: `${margin}px`,
          }}
        />
        <div className="w-full border-b border-neutral-900" />
        <div
          style={{
            height: `${margin}px`,
            minHeight: `${margin}px`,
            maxHeight: `${margin}px`,
          }}
        />
      </div>
    );
  };

export default TermsAndConditionsRenderSpacer;
